import { firebaseMutations, firebaseAction } from 'vuexfire'

const state = {
  general: [],
  work: [],
  information: [],
  project: [],
  privateProject: [],
  letters: ['#F2D7D7', '#CCF2D4', '#FCD3A7', '#FFF9BE', '#E5D4FC', '#FCC6BB', '#DFE8EA', '#D2E1FC'],
  backgroundColor: '#F2D7D7'
}

const getters = {
  general: state => state.general,
  work: state => state.work,
  information: state => state.information,
  projects: state => state.project,
  privateProjects: state => state.privateProject
}

const mutations = {
  SETRANDOMBACKGROUNDCOLOR (state) {
    state.backgroundColor = state.letters[Math.floor(Math.random() * state.letters.length)]
    document.body.style.background = state.backgroundColor
  },
  ...firebaseMutations
}

const actions = {
  setGeneralRef: firebaseAction(({
    bindFirebaseRef
  }, ref) => {
    bindFirebaseRef('general', ref)
  }),
  setWorkRef: firebaseAction(({
    bindFirebaseRef
  }, ref) => {
    bindFirebaseRef('work', ref)
  }),
  setInformationRef: firebaseAction(({
    bindFirebaseRef
  }, ref) => {
    bindFirebaseRef('information', ref)
  }),
  setProjectRef: firebaseAction(({
    bindFirebaseRef
  }, ref) => {
    bindFirebaseRef('project', ref)
  }),
  setPrivateProjectRef: firebaseAction(({
    bindFirebaseRef
  }, ref) => {
    bindFirebaseRef('privateProject', ref)
  })
}

export default {
  state,
  mutations,
  actions,
  getters
}
